<template>
  <div class="main">
    <div class="content_view">
      <div class="title">
        <p>确认信息</p>
        <div></div>
      </div>
      <div class="title_">
        <p>培训时间</p>
        <p>{{ begainTime + "-" + endTime }}</p>
      </div>
      <div class="title_">
        <p>任务安排：</p>
      </div>
    </div>
    <div class="table_view">
      <el-table :data="tableData" height="460" border style="width: 100%">
        <el-table-column prop="itemName" label="任务名" width="180">
        </el-table-column>
        <el-table-column prop="typeName" label="类型" width="180">
        </el-table-column>
        <el-table-column prop="PriorityLabel" label="优先级" width="180">
        </el-table-column>
        <el-table-column prop="date" label="学分" width="180">
          <template slot-scope="scope">
            {{ scope.row.score }}
          </template>
        </el-table-column>
        <el-table-column prop="1" label="进行时间" width="180">
          <template slot-scope="scope">
            {{
              $moment(scope.row.itemBeginTime).format("YYYY/MM/DD") +
              " - " +
              $moment(scope.row.itemEndTime).format("YYYY/MM/DD")
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="button_view">
      <div>
        <el-button type="primary" @click="stepPrevious">上一步</el-button>
        <el-button type="primary" @click="nextStep">完成</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import training from "@/api/trainingApi";
export default {
  data() {
    return {
      itemList: [],
      begainTime: "",
      endTime: "",
      tableData: [],
    };
  },
  props: ["cutcoms"],
  methods: {
    stepPrevious() {
      this.cutcoms(4);
    },
    async nextStep() {
      // 最后一步完成删除
      const deleteArr = JSON.parse(sessionStorage.getItem("deleteArr")); // 获取需要删除的数据
      if (deleteArr) {
        const obj = {
          trainId: this.$parent.examRow.tranid || this.$route.query.trainId,
          scoreIdArr: JSON.stringify(deleteArr),
        };
        const { data } = await training.delete(obj);
        console.log(data);
      }
      // 提交完成
      const parameter = {
        trainId: this.$parent.examRow.tranid || this.$route.query.trainId,
        config: "",
        passScore:this.$parent.passScore
      };
      const config = this.tableData.map((item) => {
        const obj = {
          scoreId: item.scoreId,
          priority: item.Priority,
          score: item.score,
          condition: item.Condition,
        };
        return obj;
      });
      parameter.config = JSON.stringify(config);
      const { data } = await training.config(parameter);
      if (data.Status == 200) {
        sessionStorage.removeItem("deleteArr");
        sessionStorage.removeItem("stateMenuList");
        this.$message({
          message: "恭喜你，提交成功!",
          type: "success",
        });
        this.cutcoms(0);
        this.$router.push("manage");
        this.$destroy();
      } else {
        this.$message.error(data.Data);
      }
      console.log(data, "提交咯");
    },
    init() {
      /*
      优先级高的排上面，优先级同，则学分高的放上面，都相同就按创建时间早的放上面。
      */
      this.itemList = JSON.parse(sessionStorage.getItem("stateMenuList"));
      this.begainTime = this.itemList[0].begainTime;
      this.endTime = this.itemList[0].endTime;
      let newarr1 = []; // 高
      let newarr2 = []; // 中
      let newarr3 = []; // 低
      let newarr4 = []; // 空

      this.itemList.forEach((item) => {
        item.dataListArr.forEach((zitem) => {
          if (zitem.Priority == 1) {
            zitem.PriorityLabel = "高";
            newarr1.push(zitem);
            // if(zitem.score)
          } else if (zitem.Priority == 2) {
            zitem.PriorityLabel = "中";
            newarr2.push(zitem);
          } else if (zitem.Priority == 3) {
            zitem.PriorityLabel = "低";
            newarr3.push(zitem);
          } else {
            zitem.PriorityLabel = "未设置";
            newarr4.push(zitem);
          }
        });
      });
      //   newarr1 = newarr1.sort((a, b) => a.Priority - b.Priority);
      newarr1 = newarr1.sort((a, b) => b.score - a.score);
      newarr2 = newarr2.sort((a, b) => b.score - a.score);
      newarr3 = newarr3.sort((a, b) => b.score - a.score);
      newarr4 = newarr4.sort((a, b) => b.score - a.score);

      this.tableData = newarr1.concat(newarr2, newarr3, newarr4);
      //   this.tableData.forEach(sitem=>{
      //     sitem.itemBeTginTime1 =
      //   })
      console.log(this.tableData);
    },
  },
  activated() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  min-height: 780px;
  position: relative;
  .content_view {
    padding: 24px;
  }
  .title {
    display: flex;
    align-items: center;
    > p {
      font-size: 22px;
      margin-right: 24px;
    }
    > div {
      border-bottom: 1px solid #e3e6eb;
      width: 50%;
      height: 1px;
    }
  }
  .title_ {
    display: flex;
    align-items: center;
    margin-top: 24px;
    > p {
      &:nth-child(1) {
        font-size: 22px;
        margin-right: 24px;
      }
      &:nth-child(2) {
        font-size: 18px;
        color: #1cb0f2;
      }
    }
  }
}
.button_view {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 4%;
  // margin-top: 12%;
  > div {
    display: flex;
    padding: 16px;
    > .el-button {
      width: 120px;
      margin-right: 16px;
    }
  }
}
::v-deep .cell {
  text-align: center;
}
.table_view {
  padding: 24px;
}
</style>